var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"qrcode"},_vm._l((_vm.list),function(item){return _c('div',{attrs:{"v-bind":item.id}},[_c('span',[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('div',{attrs:{"id":'qrcode'+item.id}}),_vm._v(" "),_c('span',[_c('label',[_vm._v(_vm._s(item.type))]),_vm._v(" "),_c('label',[_vm._v(_vm._s(item.time)+"-"+_vm._s(item.id))])])])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7616e2ee","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/qrCode.vue
// module id = null
// module chunks = 